import { useContext } from 'react';
import ClientsContext from 'contexts/clients/ClientsContext';

export default function useContextClients() {
  const context = useContext(ClientsContext);

  if (context === undefined) {
    throw new Error('useContextClients must be used within a ClientsProvider');
  }

  return context;
}
